import { render, staticRenderFns } from "./LocationToOfficePopup.vue?vue&type=template&id=5b4f8de6&"
import script from "./LocationToOfficePopup.vue?vue&type=script&lang=js&"
export * from "./LocationToOfficePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports